import { motion } from "framer-motion";
import { FadeIn, StaggeredGrid } from "@/components/animated";
import { Card } from "@learn-me/ui";
import { testimonials } from "@/data/homePageData";
import { Star, Quote } from "lucide-react";

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          className={`h-4 w-4 ${
            i < rating
              ? "text-gold-400 fill-gold-400"
              : "text-secondary-200 fill-secondary-200"
          }`}
        />
      ))}
    </div>
  );
}

export function TestimonialsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container">
        <FadeIn>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 bg-gold-100 text-gold-700 text-sm font-medium rounded-full mb-4">
              Testimonios Reales
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
              Lo que dicen nuestros estudiantes
            </h2>
            <p className="text-secondary-600 max-w-2xl mx-auto">
              Historias de éxito de profesionales que transformaron sus carreras
            </p>
          </div>
        </FadeIn>

        <StaggeredGrid
          className="grid md:grid-cols-3 gap-8"
          staggerDelay={0.15}
        >
          {testimonials.map((testimonial) => (
            <motion.div
              key={testimonial.id}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
              className="h-full"
            >
              <Card className="p-6 h-full border-0 shadow-lg hover:shadow-premium transition-shadow relative overflow-hidden">
                {/* Quote decoration */}
                <Quote className="absolute top-4 right-4 h-12 w-12 text-primary-100 rotate-180" />

                {/* Rating */}
                <div className="mb-4 relative z-10">
                  <StarRating rating={testimonial.rating} />
                </div>

                {/* Quote */}
                <blockquote className="text-secondary-700 mb-6 relative z-10 leading-relaxed">
                  "{testimonial.quote}"
                </blockquote>

                {/* Author */}
                <div className="flex items-center gap-4 mt-auto relative z-10">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover ring-2 ring-primary-100"
                  />
                  <div>
                    <p className="font-semibold text-secondary-900">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-secondary-500">
                      {testimonial.role} en {testimonial.company}
                    </p>
                  </div>
                </div>

                {/* Course badge */}
                <div className="mt-4 pt-4 border-t border-secondary-100 relative z-10">
                  <p className="text-xs text-secondary-500">
                    Curso completado:{" "}
                    <span className="font-medium text-primary-600">
                      {testimonial.courseCompleted}
                    </span>
                  </p>
                </div>
              </Card>
            </motion.div>
          ))}
        </StaggeredGrid>
      </div>
    </section>
  );
}
